<nz-spin [nzSpinning]="isSpinning">
  <div class="page-content">
    <div class="title-box">
      <span class="title">{{ "USER-MANAGEMENT" | translate }}</span>
    </div>
    <div class="filter-box">
      <div class="filter-list">
        <div class="filter-item">
          <span>{{ "FILTER_USER_NAME" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearUserName">
            <input
              nz-input
              [placeholder]="'PLEASE_INPUT_USER_NAME' | translate"
              [(ngModel)]="params.name"
            />
          </nz-input-group>
          <ng-template #inputClearUserName>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.name"
              (click)="params.name = ''"
            ></i>
          </ng-template>
        </div>
        <div class="filter-item">
          <span>{{ "NT" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearNT">
            <input
              nz-input
              [placeholder]="'PLEASE_INPUT_NT' | translate"
              [(ngModel)]="params.ntAccount"
            />
          </nz-input-group>
          <ng-template #inputClearNT>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.ntAccount"
              (click)="params.ntAccount = ''"
            ></i>
          </ng-template>
        </div>
        <div class="filter-item">
          <span>{{ "EMAIL" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearEmail">
            <input
              nz-input
              [placeholder]="'PLEASE_INPUT_EMAIL' | translate"
              [(ngModel)]="params.email"
            />
          </nz-input-group>
          <ng-template #inputClearEmail>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.email"
              (click)="params.email = ''"
            ></i>
          </ng-template>
        </div>
        <div class="filter-item">
          <span>{{ "DEPARTMENT" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearDept">
            <input
              nz-input
              [placeholder]="'PLEASE_INPUT_DEPARTMENT' | translate"
              [(ngModel)]="params.department"
            />
          </nz-input-group>
          <ng-template #inputClearDept>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.department"
              (click)="params.department = ''"
            ></i>
          </ng-template>
        </div>
      </div>
      <div class="filter-ctrl">
        <button nz-button nzType="primary" (click)="onSearch()">
          <i nz-icon nzType="search" nzTheme="outline"></i>
          <span>{{ "SEARCH" | translate }}</span>
        </button>
        <button nz-button nzType="default" (click)="onClear()">
          <i nz-icon nzType="close" nzTheme="outline"></i>
          <span>{{ "CLEAR" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="container">
      <nz-table
        #basicTable
        [nzData]="dataSource"
        [nzFrontPagination]="false"
        [nzServerRender]="true"
        [nzTotal]="pagination.total"
        [nzPageIndex]="pagination.pageIndex"
        [nzPageSize]="pagination.pageSize"
        [nzPageSizeOptions]="pagination.pageSizeOptions"
        (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)"
        [nzScroll]="{ y: 'calc(100vh - 380px)' }"
        nzShowSizeChanger
        nzShowQuickJumper
        [nzShowTotal]="totalTemplate"
        [nzWidthConfig]="widthConfig"
      >
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.name | translate }}</th>
            <th>{{ "OPERATIONS" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td *ngFor="let col of columns">
              <ng-container *ngIf="col.key !== 'roleNameList'">
                {{ data[col.key] }}
              </ng-container>
              <ng-container *ngIf="col.key === 'roleNameList'">
                <div class="role-tag-box">
                  <span
                    *ngFor="let item of data.roleNameList.split(',')"
                    class="role-tag"
                  >
                    {{ item }}
                  </span>
                </div>
              </ng-container>
            </td>
            <td class="opreations">
              <i
                nz-icon
                nzType="edit"
                nzTheme="outline"
                (click)="onEditUser(data)"
                nz-tooltip
                [nzTooltipTitle]="'EDIT' | translate"
              ></i>
              <i
                nz-icon
                nzType="delete"
                nzTheme="outline"
                nz-popconfirm
                [nzPopconfirmTitle]="
                  'DELETE_USER_POP_CONFIRM' | translate : { name: data.name }
                "
                (nzOnConfirm)="onDelete(data)"
                nzPopconfirmPlacement="topLeft"
                nz-tooltip
                [nzTooltipTitle]="'DELETE' | translate"
              ></i>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>{{
        "TOTAL_ITEM" | translate : { total }
      }}</ng-template>
    </div>
  </div>
</nz-spin>
<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="'NEW_ADD_USER' | translate"
  (nzOnCancel)="onCancel()"
  (nzOnOk)="onSave()"
  nzWidth="808px"
>
  <ng-container *nzModalContent>
    <form
      nz-form
      [formGroup]="validateModuleForm"
      (ngSubmit)="isVisible = false"
    >
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="ntAccount">{{
          "NT_ACCOUNT" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="'PLEASE_INPUT_NT' | translate"
        >
          <input
            nz-input
            formControlName="ntAccount"
            id="ntAccount"
            [placeholder]="'PLEASE_INPUT_NT' | translate"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="name">{{
          "USER_NAME" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="'PLEASE_INPUT_USER_NAME' | translate"
        >
          <input
            nz-input
            formControlName="name"
            id="name"
            [placeholder]="'PLEASE_INPUT_USER_NAME' | translate"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="department">{{
          "DEPARTMENT" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="'PLEASE_INPUT_DEPARTMENT' | translate"
        >
          <input
            nz-input
            formControlName="department"
            id="department"
            [placeholder]="'PLEASE_INPUT_DEPARTMENT' | translate"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="email">{{
          "EMAIL" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="'PLEASE_INPUT_EMAIL' | translate"
        >
          <input
            nz-input
            formControlName="email"
            id="email"
            [placeholder]="'PLEASE_INPUT_EMAIL' | translate"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="roleIds">{{
          "ROLE_NAME" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="'PLEASE_SELECT_ROLE' | translate"
        >
          <nz-select
            formControlName="roleIds"
            id="roleIds"
            [nzPlaceHolder]="'PLEASE_SELECT_ROLE' | translate"
            nzMode="multiple"
          >
            <nz-option
              *ngFor="let role of roleList"
              [nzValue]="role.id.toString()"
              [nzLabel]="role.name"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
